import { h, render, Component } from 'preact';

class SelectBox extends Component {

	constructor(props) {
		super(props);

		this.state = { value: this.props.defaultValue};
	}

	render() {

		let options = this.props.options;
		return (
			<select
				id={this.props.id}
				className={this.props.className}
				aria-label={this.props.ariaLabel}
				value={this.props.defaultValue}
				onChange={this.props.onChange}
			>
				{options.map(option => {
					return <option value={option} key={option} >{option}</option>
				})}
			</select>
		)
	}

	get defaultValue() {
		return this.props.defaultValue || '';
	}
}

export default SelectBox;
